import { LOCALES } from './locale';

export enum GraveType {
  PLOT = 'plot',
  CREMATION_PLOT = 'cremation plot',
}

export enum MausoleumType {
  NICHE = 'niche',
  CRYPT = 'crypt',
}

export const BurialType: Record<string, string> = {
  [GraveType.PLOT]: LOCALES.PLOT,
  [GraveType.CREMATION_PLOT]: 'Cremation plot',
  [MausoleumType.NICHE]: 'Niche',
  [MausoleumType.CRYPT]: 'Crypt',
};
